/* Dorian */
/**
 * Collection entry log — fires once when the shopper lands on a collection
 * page. Prints the numeric collection ID to the console.
 *
 * The collection ID is injected server-side by theme.liquid as
 * window.__currentCollectionId on collection pages only. If it isn't set,
 * we're not on a collection page (or the layout snippet didn't render).
 *
 * Set WATCHED_COLLECTION_IDS to a list of numeric IDs (as strings or numbers)
 * to limit firing to specific collections. Empty list = fire on every
 * collection page.
 */

(function () {
    // Add IDs here to gate firing. Empty array = fire on every collection.
    var WATCHED_COLLECTION_IDS = [];

    function run() {
        var id = window.__currentCollectionId;
        if (!id) return; // not a collection page

        if (WATCHED_COLLECTION_IDS.length > 0) {
            var idStr = String(id);
            var match = WATCHED_COLLECTION_IDS.some(function (x) { return String(x) === idStr; });
            if (!match) return;
        }

        console.log('[collection-entry] User entered collection ID : ' + id);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();
